import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=2f469e43&scoped=true&"
import script from "./newsDetail.vue?vue&type=script&lang=js&"
export * from "./newsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsDetail.vue?vue&type=style&index=1&id=2f469e43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f469e43",
  null
  
)

export default component.exports